export default __webpack_public_path__ + "static/media/Logo.03c77f76.png";